function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Component_13",
  "data-name": "Component 13",
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_215",
  "data-name": "Group 215",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_303",
  "data-name": "Path 303",
  d: "M729.414,225.649,729.4,220.8l9.9-5.1,9.937,4.928.056,16.907-7.773.026H729.4l.016-8.774",
  transform: "translate(-729.398 -215.695)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_116",
  "data-name": "Rectangle 116",
  width: 3.721,
  height: 3.721,
  transform: "translate(8.033 7.044) rotate(-0.188)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_216",
  "data-name": "Group 216",
  transform: "translate(19.838 3.958)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_304",
  "data-name": "Path 304",
  d: "M756.135,223.325l4.455-2.3,7.793,3.865.044,13.26-6.1.02h-6.147",
  transform: "translate(-756.135 -221.029)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_117",
  "data-name": "Rectangle 117",
  width: 2.919,
  height: 2.919,
  transform: "translate(2.991 5.525) rotate(-0.188)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})));

var SvgJoratoProperties = function SvgJoratoProperties(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.13,
    height: 22.86,
    viewBox: "0 0 33.13 22.86",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoProperties, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-properties.2d30472f.svg";
export { ForwardRef as ReactComponent };